
import Vue from 'vue'

import { candidateApi } from '@/api'
import { Candidate } from '@/api/candidate'
import AddCandidate from '@/components/codegen/AddCandidate.vue'

export default Vue.extend({
  name: 'Candidates',
  components: { AddCandidate },
  data() {
    return { candidates: [] as Candidate[] }
  },
  async created() {
    await this.getCandidates()
  },
  methods: {
    async deleteCandidate(id?: number) {
      if (id != null) {
        await candidateApi.deleteCandidate(id)
        await this.getCandidates()
      }
    },
    async getCandidates() {
      const candidatesResponse = await candidateApi.getCandidates()
      this.candidates = candidatesResponse.data
    }
  }
})
